import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { getResponseIconWithColor, getResponseLabel } from 'app/events/helpers/event-response-helpers';
import { CalendarEventResponseStatusEnum } from 'generated/graphql';

@Component({
  selector: 'app-event-response-status-filter',
  templateUrl: './event-response-status-filter.component.html',
  styleUrls: ['./event-response-status-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventResponseStatusFilterComponent implements  OnChanges {
  @Input() selections: any[] = [];
  @Input() includeDeclined = false;
  @Output() selectionChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  // Form control
  responseFormCtrl = new FormControl();
  // Track when allAttending option is selected/deselected
  currentValue = [];

  // Helpers
  ResponseEnum = CalendarEventResponseStatusEnum;
  getIconWithColor = getResponseIconWithColor;
  getLabel = getResponseLabel;

  rsvpOptions = [
    CalendarEventResponseStatusEnum.Rsvp,
    CalendarEventResponseStatusEnum.Confirmed,
    CalendarEventResponseStatusEnum.DoubleConfirmed,
  ];

  attendanceOptions = [
    CalendarEventResponseStatusEnum.Attended,
    CalendarEventResponseStatusEnum.NoShow,
  ];

  orderedResponses = [
    ...this.rsvpOptions,
    CalendarEventResponseStatusEnum.Tentative,
    CalendarEventResponseStatusEnum.Declined,
    ...this.attendanceOptions,
  ];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selections) {
      let newSelections = this.selections;
      // Check if allAttending option should be selected
      if (this.selections.filter(s => this.rsvpOptions.includes(s)).length === this.rsvpOptions.length) {
        newSelections = [...this.selections, 'allAttending'];
      }
      this.responseFormCtrl.setValue(newSelections);
      this.currentValue = newSelections;
    }
  }


  getSelectionDisplay(responses): string {
    if (!responses || responses.length === 0) { return ''; }
    // Keep in order
    return this.orderedResponses.filter(s => responses.includes(s))
      .map(this.getLabel).join(', ');
  }

  onSelectionChange({ value: newValue }: MatSelectChange) {
    const newSelections = new Set(newValue);
    // Check for allAttending option
    if (newValue.includes('allAttending')) {
      // If an attending option was deselected, deselect the allAttending option
      if (this.currentValue.includes('allAttending') &&
        this.currentValue.filter(s => this.rsvpOptions.includes(s)).length >
        newValue.filter(s => this.rsvpOptions.includes(s)).length) {
        this.responseFormCtrl.setValue(newValue.filter(s => s !== 'allAttending'));
        newSelections.delete('allAttending');
      } else {
        // Check all rsvpOptions on form control
        this.responseFormCtrl.setValue([...newValue, ...this.rsvpOptions]);
        // Add all RSVP options to selections
        this.rsvpOptions.forEach(rsvp => newSelections.add(rsvp));
      }
    } else {
      // Check if allAttending was just unchecked
      if (this.currentValue.includes('allAttending')) {
        // Remove all rsvpOptions from selections
        this.rsvpOptions.forEach(rsvp => newSelections.delete(rsvp));
        // Remove all rsvpOptions from form control
        this.responseFormCtrl.setValue(newValue.filter(s => !this.rsvpOptions.includes(s)));
      }
    }
    this.currentValue = Array.from(newSelections);
    // Remove allAttending from selections
    newSelections.delete('allAttending');
    this.selectionChange.emit(Array.from(newSelections));
  }
}
